module.exports = __webpack_public_path__ + "img/expenses.2649222f.svg";